import React from 'react';
import { NavItem } from './types';
import { AppSidebarSection } from './app-sidebar-section';
import { ANIMATION_DURATION } from './constants';

interface AppSidebarBottomSectionProps {
  items: NavItem[];
  isCollapsed: boolean;
  pathname: string;
  onNavigate?: (href: string, isExternal: boolean) => void;
  isExtended?: boolean;
}

/**
 * Bottom section of the sidebar with border and custom padding.
 * Uses AppSidebarSection internally to avoid duplication.
 */
export function AppSidebarBottomSection({
  items,
  isCollapsed,
  pathname,
  onNavigate,
  isExtended = false,
}: AppSidebarBottomSectionProps) {
  return (
    <div
      className="tw-mt-auto tw-min-w-0 tw-w-full tw-border-t"
      style={{
        marginTop: 'auto',
        paddingTop: isCollapsed ? '4px' : '24px',
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 0,
        borderTopColor: '#e5e7eb',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        boxSizing: 'border-box' as const,
        transition: `padding-top ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      }}
    >
      <AppSidebarSection
        items={items}
        isCollapsed={isCollapsed}
        pathname={pathname}
        showBorder={false}
        className="tw-w-full"
        onNavigate={onNavigate}
        isExtended={isExtended}
      />
    </div>
  );
}
